var _defs, _rect, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReaccessSymbolBlueBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 128,
    y1: 256,
    x2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a88d8"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 256,
    rx: 55.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.67 113.79 64.64 223.88 64.64 49.82 121.87 49.82 96.94 113.79 113.67 113.79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.17,158.3l45.7-64.54h-18l26.54-41.28a49.27,49.27,0,0,1,33.2,46.58,59.34,59.34,0,0,1-38.23,55.41l37.86,69.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaccessSymbolBlueBackground);
export default __webpack_public_path__ + "static/media/reaccess-symbol-blue-background.ea9d977cf5e406201fedf9fad09fc0b2.svg";
export { ForwardRef as ReactComponent };